
import { Language } from "../types";

export const translations = {
  en: {
    appTitle: "PROMPT_CTF",
    missionLog: "Mission Log",
    user: "User",
    flags: "Flags",
    signOut: "Sign Out",
    settings: "Settings",
    missionObjective: "Mission Objective",
    failureExample: "Failure Example",
    promptEditor: "Prompt Editor",
    reset: "Clear",
    run: "Run & Verify",
    compiling: "Compiling...",
    processing: "Processing stream...",
    waiting: "Awaiting System Check...",
    passed: "PASSED",
    failed: "FAILED",
    verdict: "JUDGE_AI_VERDICT",
    loginTitle: "Sign in to Prompt CTF",
    loginSubtitle: "Master the art of prompt engineering",
    continueGoogle: "Continue with Google",
    continueGithub: "Continue with GitHub",
    continueLinuxdo: "Connect with Linux.do",
    continueEmail: "Sign in with Email",
    emailPlaceholder: "name@example.com",
    inputPlaceholder: "// Enter your prompt here...\n// Press Run to test.",
    systemOutput: "SYSTEM_OUTPUT",
    level: "Level",
    history: "History",
    restore: "Restore",
    noHistory: "No attempts yet.",
    leaderboard: "Leaderboard",
    rank: "Rank",
    player: "Player",
    score: "Flags Captured",
    lastActive: "Last Active",
    backToGame: "Back to Game",
    chapters: {
      ch1: "1. Foundations & Persona",
      ch2: "2. Reasoning & Few-Shot",
      ch3: "3. Advanced Patterns",
      ch4: "4. Interaction Design",
      ch5: "5. Engineering & Security",
      ch6: "6. CTF Labs"
    }
  },
  zh: {
    appTitle: "提示词竞技场",
    missionLog: "任务日志",
    user: "用户",
    flags: "夺旗数",
    signOut: "退出登录",
    settings: "设置",
    missionObjective: "任务目标",
    failureExample: "失败案例",
    promptEditor: "提示词编辑器",
    reset: "清空",
    run: "运行并验证",
    compiling: "运行中...",
    processing: "正在处理...",
    waiting: "等待系统检测...",
    passed: "挑战成功",
    failed: "挑战失败",
    verdict: "AI 裁判判定",
    loginTitle: "登录 Prompt CTF",
    loginSubtitle: "通过实战掌握提示词工程",
    continueGoogle: "使用 Google 登录",
    continueGithub: "使用 GitHub 登录",
    continueLinuxdo: "使用 Linux.do 登录",
    continueEmail: "使用邮箱登录",
    emailPlaceholder: "你的邮箱地址",
    inputPlaceholder: "// 在此输入提示词...\n// 点击运行进行测试。",
    systemOutput: "系统输出",
    level: "关卡",
    history: "历史记录",
    restore: "恢复",
    noHistory: "暂无记录。",
    leaderboard: "排行榜",
    rank: "排名",
    player: "选手",
    score: "夺旗数",
    lastActive: "最后活跃",
    backToGame: "返回挑战",
    chapters: {
      ch1: "1. 基础篇 · 角色与约束",
      ch2: "2. 技巧篇 · 推理与少样本",
      ch3: "3. 进阶篇 · 高级设计模式",
      ch4: "4. 交互篇 · 翻转与协作",
      ch5: "5. 工程篇 · 安全与防御",
      ch6: "6. 实验室 · 极限挑战"
    }
  }
};

export const getTranslation = (lang: Language) => translations[lang];
